import { log2 } from "../../utils/log2";
import moment from "moment";
import "moment/locale/tr";

const log = log2("language");
const langs = {
    tr: {
        name: "Turkish",
        code: "tr",
    },
    en: {
        name: "English",
        code: "en",
    },
    ru: {
        name: "Russian",
        code: "ru",
    },
    de: {
        name: "German",
        code: "de",
    },
    fr: {
        name: "French",
        code: "fr",
    },
    es: {
        name: "Spanish",
        code: "es",
    },
    ar: {
        name: "Arabic",
        code: "ar",
    },
    it: {
        name: "Italian",
        code: "it",
    },
};
const language = {
    namespaced: true,
    state: {
        languages: [langs.tr, langs.en, langs.ru, langs.de, langs.fr, langs.ar, langs.es, langs.it],
        language: langs.en,
    },
    mutations: {
        SET_LANGUAGE: (state, language) => {
            state.language = language;
            moment.locale(language.code);
        },
    },
    actions: {
        setLanguage({ commit, state }, payload) {
            log.debug("setLanguage called", payload);
            const lang = state.languages.filter((language) => language.code === payload)[0] || langs.en;
            commit("SET_LANGUAGE", lang);
        },
    },
};

export default language;



// WEBPACK FOOTER //
// ./src/store/modules/language.js